export default "__VITE_ASSET__gAUl2dzl__"